import { Fragment } from "react";
import { Button } from "@mui/material";
import { Done } from "@mui/icons-material";
import EventPreviewSkeleton from "../../../components/event-preview/EventPreviewSkeleton";
import EventDetailBanner from "../../../components/Cards/EventDetailBanner";
import MoreEventDetail from "../../../components/EventMetaDescription/MoreEventDetail";
// import UserLikesEvents from "./UserLikesEvents";
import useEventSpecificDetails from "../../../hooks/event-hooks/useEventSpecificDetails"
import TicketBuyingFlow from "./TicketBuyingFlow";
import NotFound from "../../../pages/404/NotFound";
import { H5 } from "../../../themes/typography";
import "../../../styles/event/EventSpecificDetails.css"

function EventSpecificDetails() {
    const {
        eventData,
        loading,
        eventDate,
        eventTimingUI,
        fcs,
        minimumTicketPrice,
        eventDurationUI,
        eventScheduleRef,
        getTickets,
        showTickets,
        error,
        showRsvp,
        handleRsvp,
        showRsvpResponseMessage,
        inviteLinkUserDetails,
        setShowRsvp,
        handleMarkAsInterested,
        isUserMarkEventAsInterested
    } = useEventSpecificDetails();


    if (loading) {
        return (
            <div className="page-view">
                <div className="page-wrapper">
                    <EventPreviewSkeleton />
                </div>
            </div>
        )
    }


    if (error && !loading) {
        switch (error?.code) {
            case 404:
                return (
                    <NotFound
                        statusCode={error?.code}
                        pageTitle="Event Not Found"
                        description="The event you are looking for does not exist or has been removed."
                        shouldShowBgGradient={false}
                    />
                );
            case 401:
                return (
                    <NotFound
                        statusCode={error?.code}
                        pageTitle="Unauthorized"
                        description="You do not have permission to access this event."
                        shouldShowBgGradient={false}
                    />
                );
            case 500:
                return (
                    <NotFound
                        statusCode={error?.code}
                        pageTitle="Internal Server Error"
                        description="An unexpected error occurred on the server. Please try again later."
                        shouldShowBgGradient={false}
                    />
                );
            default:
                return (
                    <NotFound
                        statusCode={error?.code}
                        pageTitle="An Error Occurred"
                        description="An unexpected error occurred. Please try again later."
                        shouldShowBgGradient={false}
                    />
                );
        }
    }

    // console.log("eventData", eventData);

    return (
        <div className="page-view">

            <div className="page-wrapper">

                <section id="main-event-detail-public-container">
                    {showRsvp && (eventData?.status === 'scheduled' || eventData?.status === 'Scheduled') && (
                        <div className="rsvp-response-container">
                            <H5 fontWeight={300}>
                                You have been invited to this event. Please respond.
                            </H5>
                            <div className="rsvp-response-buttons">
                                <Button
                                    variant="success"
                                    onClick={() => handleRsvp(true)}
                                    startIcon={inviteLinkUserDetails?.response === 'yes' ? <Done /> : null}
                                    sx={{ pointerEvents: inviteLinkUserDetails?.response === 'yes' ? 'none' : 'auto', textTransform: 'none' }}
                                >
                                    Yes, I will attend
                                </Button>
                                <Button
                                    variant="markAsSoldOut"
                                    onClick={() => handleRsvp(false)}
                                    startIcon={inviteLinkUserDetails?.response === 'no' ? <Done /> : null}
                                    sx={{ pointerEvents: inviteLinkUserDetails?.response === 'no' ? 'none' : 'auto', textTransform: 'none' }}
                                >
                                    Not interested
                                </Button>
                            </div>
                        </div>
                    )}

                    {inviteLinkUserDetails?.response === 'yes' && !showRsvp && !showRsvpResponseMessage && (
                        <div className="rsvp-response-container">
                            <H5 fontWeight={300}>
                                Thank you for your response. You are marked as attending this event.
                            </H5>
                            <div className="rsvp-response-buttons">
                                <Button
                                    variant="markAsSoldOut"
                                    onClick={() => setShowRsvp(true)}
                                >
                                    Change my response?
                                </Button>
                            </div>
                        </div>
                    )}

                    {inviteLinkUserDetails?.response === 'no' && !showRsvp && !showRsvpResponseMessage && (
                        <div className="rsvp-response-container">
                            <H5 fontWeight={300}>
                                Thank you for your response. You are marked as not attending this event.
                            </H5>
                            <div className="rsvp-response-buttons">
                                <Button
                                    variant="markAsSoldOut"
                                    onClick={() => setShowRsvp(true)}
                                >
                                    Change my response?
                                </Button>
                            </div>
                        </div>
                    )}

                    {showRsvpResponseMessage && (
                        <div className="rsvp-response-container">
                            <H5 color="var(--secondary-color)">
                                Thank you for your response. We have recorded your response.
                            </H5>
                        </div>
                    )}

                    <EventDetailBanner
                        name={eventData?.title}
                        address={eventData?.address}
                        date={eventDate}
                        eventType={eventData?.event_type}
                        schedule={eventData?.schedules}
                        time={eventTimingUI()}
                        fcs={fcs}
                        minTicketPrice={minimumTicketPrice}
                        duration={eventDurationUI()}
                        getTickets={getTickets}
                        showTickets={showTickets}
                        status={eventData?.status}
                        handleInterestClick={handleMarkAsInterested}
                        isInterested={isUserMarkEventAsInterested}
                    />

                    {showTickets && <TicketBuyingFlow eventData={eventData} />}

                    {!showTickets && (
                        <Fragment>
                            <MoreEventDetail
                                eventData={eventData}
                                ref={eventScheduleRef}
                            />
                            {/* <UserLikesEvents /> */}
                        </Fragment>
                    )}

                </section>

            </div>

        </div>
    )
}

export default EventSpecificDetails